import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchMyPractices } from '../../store/MyPractice/MyPracticeActions';
import { updateUserAccess } from '../../store/ManageUser/manageUserActions';
import GoogleMapComponent from "../../common/GoogleMapComponent";
import { MyAccountContext } from '../../App';
import './myPractice.scss';

const MyPractice = () => {
  const [showUsersTable, setShowUsersTable] = useState(false);
  const [selectedPractice] = useState(0);
  const [confirmRemoveMap, setConfirmRemoveMap] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { user } = useContext(MyAccountContext);
  const userId = user?.displayId;
  
  const myPracticeState = useSelector(state => state.myPractice);
  const { data, isMyPracticesLoading } = myPracticeState;
  

  useEffect(() => {
    if (userId) {
      dispatch(fetchMyPractices(userId));
    }
  }, [userId]);

  const practices = data?.data?.userPracticeResponseDTO || data?.userPracticeResponseDTO || [];

  const toggleUsersTable = () => {
    setShowUsersTable(!showUsersTable);
  };

  const practice = practices[selectedPractice];
  const practiceId = practice?.practiceDisplayId;
  
  const goToDashboard = () => {
    if (practiceId) {
      navigate(`/practice/${practiceId}/profile-information/dashboard`, {
        state: { practiceName: practice?.name }
      });
    }
  };
  
  const locationData = practice ? [
    {
      lat: parseFloat(practice.latitude) || 40.7128,
      lng: parseFloat(practice.longitude) || -74.0060
    }
  ] : [
    {
      lat: 40.7128,
      lng: -74.0060
    }
  ];

  const formatAddress = (streetAddress) => {
    if (!streetAddress) return "";
    
    const { street1, street2, city, state, postalCode } = streetAddress;
    let address = street1 || "";
    if (street2) address += `, ${street2}`;
    if (city) address += `, ${city}`;
    if (state) address += `, ${state}`;
    if (postalCode) address += ` ${postalCode}`;
    
    return address;
  };

  const getActiveUsers = () => {
    if (!practice || !practice.practiceUsers) return [];
    return practice.practiceUsers.filter(user => user.access === "GRANTED");
  };

  const toggleConfirmRemove = (userId, value) => {
    if (!value) {
      setConfirmRemoveMap((prev) => {
        const newMap = { ...prev };
        delete newMap[userId];
        return newMap;
      });
    } else {
      setConfirmRemoveMap({
        [userId]: value,
      });
    }
  };

  const handleRemoveAccess = (user) => {
    dispatch(
      updateUserAccess({
        practiceId: practiceId,
        userDisplayId: user.userId,
        accessType: "REMOVED"
      })
    ).then(() => {
      toggleConfirmRemove(user.userId, false);
      dispatch(fetchMyPractices(userId));
    }).catch((error) => {
      return error;
    });
  };
  if (isMyPracticesLoading) {
    return <div className="my-practice-section">Loading practices...</div>;
  }
  if(!practices?.length){
    return <div className='no-practice-found noDataInformationWrapper'>No practices linked to your account.</div>
  }
  return (
    <div className="my-practice-section">
      <div className="map-left-container">
        <GoogleMapComponent 
          latLngList={locationData}
          zoomLevel={14}
        />
      </div>
      <div className="right-content-block">
        <span
          className={`glyphicon ${
            showUsersTable ? "glyphicon-menu-down" : "glyphicon-menu-up"
          }`}
          onClick={toggleUsersTable}
        ></span>
        <p className="practice-name">{practice ? practice.name : "Loading..."}</p>
        <p className="practice-address">{practice ? formatAddress(practice.streetAddress) : ""}</p>
        <div className="practice-buttons">
          <button className="dashBoard-btn" onClick={goToDashboard}>Go To Dashboard</button>
          <button className="btn edit-button manageAddbtn" onClick={toggleUsersTable}>Manage Users</button>
        </div>
      </div>
      
      {showUsersTable && practice && (
        <div className="users-table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>ACCOUNT MANAGER</th>
                <th>EMAIL ADDRESS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {getActiveUsers().map(user => (
                <tr key={user.userId}>
                  <td>{`${user.firstName || ''} ${user.lastName || ''}`}</td>
                  <td>{user.username}</td>
                  <td>
                    {confirmRemoveMap[user.userId] ? (
                      <>
                        <a 
                          className="cancel-btn"
                          onClick={() => toggleConfirmRemove(user.userId, false)}
                        >
                          CANCEL
                        </a>
                        <a 
                          className="confirm-btn"
                          onClick={() => handleRemoveAccess(user)}
                        >
                          CONFIRM
                        </a>
                      </>
                    ) : (
                      <a 
                        className="userLastLink"
                        onClick={() => toggleConfirmRemove(user.userId, true)}
                      >
                        REMOVE
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MyPractice;